import usePageTitle from "@/hooks/usePageTitle";
import { Navigate, useLocation } from "react-router-dom";

export default function PersonIndexPage() {
  usePageTitle("/education/videos", "Education | Videos");
  const location = useLocation();
  return <Navigate to={`${location.pathname}/videos`} replace />;
}
